import { css } from '@emotion/core'
import { Person } from '@fs/zion-person'
import { colors, H1, LayoutBand, Row, Separator, Skeleton, WhiteTheme } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import ResearchHelpTabsSkeleton from './components/ResearchHelpTabsSkeleton'
import SkeletonAnimationSyncDecorator from '../common/SkeletonAnimationSyncDecorator'

const minHeightCss = css`
  min-height: 80px;
`

const tuckInSizeCss = css`
  /** Adjusts the margin to tuck in the icon button just like the normal low emphasis IconButton*/
  margin: 0 -8px;
`

function PersonBandSkeleton(): JSX.Element {
  return (
    <LayoutBand maxWidth="lg" marginY="xxs" marginX="xxs" color={colors.gray80}>
      <WhiteTheme>
        <Row guttersX="xs" css={minHeightCss} alignY="middle">
          <div css={tuckInSizeCss}>
            {/* eslint-disable-next-line test-selectors/button -- NA */}
            <Skeleton.IconButton />
          </div>
          <Person loading avatarSize="smaller" lifespanSize="long" />
        </Row>
      </WhiteTheme>
    </LayoutBand>
  )
}

export default function ResearchHelpPageSkeleton(): JSX.Element {
  const [t] = useTranslation()
  return (
    <SkeletonAnimationSyncDecorator>
      <PersonBandSkeleton />

      <Separator size="sm" />

      <LayoutBand maxWidth="lg">
        <H1 size="H5">{t('tree-person.research-help.label')}</H1>
        <Separator size="sm" />
        <ResearchHelpTabsSkeleton />
      </LayoutBand>
    </SkeletonAnimationSyncDecorator>
  )
}
